import { init, t } from 'i18next'
import { z } from 'zod'
import { makeZodI18nMap } from 'zod-i18n-map'
import translationDe from 'zod-i18n-map/locales/de/zod.json'
import translationEn from 'zod-i18n-map/locales/en/zod.json'
import { defineNuxtPlugin } from '#imports'

declare global {
  interface Window {
    z: typeof z
    zod: typeof z
  }
}
window.z = z
window.zod = z

/**
 * Translates error messages from parsing objects
 *
 * https://github.com/aiji42/zod-i18n
 */
export default defineNuxtPlugin({
  async setup() {
    // @ts-expect-error: missing and needs to be extended
    translationDe.errors.invalid_string.date = 'Ungültiges Datum'
    // @ts-expect-error: missing and needs to be extended
    translationEn.errors.invalid_string.date = 'Invalid Date'

    translationDe.errors.too_small.array.inclusive = 'Muss mindestens {{minimum}} Element(e) enthalten'
    translationDe.errors.too_small.array.not_inclusive = 'Muss muss mehr als {{minimum}} Element(e) enthalten'
    translationDe.errors.too_small.array.exact = 'Muss genau {{minimum}} Element(e) enthalten'
    await init({
      lng: 'de',
      resources: {
        de: {
          zod: translationDe,
        },
        en: {
          zod: translationEn,
        },
      },
    })
    const errorMap = makeZodI18nMap({ ns: 'zod', t })
    z.setErrorMap((issue, _ctx) => {
      return errorMap(issue, _ctx)
    })
  },
})
